import Dialog from "../1. Core/Controls/Dialog/Dialog";

import {Card, UserCard} from "./types";

import {ServerAPI} from "../1. Core/ServerAPI";
import DataTable from "../1. Core/Controls/DataTable/DataTable";
import NP from "../1. Core/NP";
import {Location} from "../10. Battle/types";
import LocDialog from "../10. Battle/Library/Dialogs/LocDialog";
import MetaLevelEditDialog from "./MetaLevelEditDialog";


export default class MetaLevelsListDialog extends Dialog {

	private _dataTable: DataTable;


	_initFields(settings: object)
	{

		super._initFields(settings);
		this._Mode = 'FullHeight';
		this._Caption = 'User levels';
		this._CloseOnFrameMouseDown = true;
		this._ShowHeader = true;
		this._ShowCloseButton = true;
		this._ShowButtons = false;
		this._AutoDestroy = true;
	}

	_render()
	{
		super._render();

		this.setContent(this._dataTable = new DataTable({
			Class: 'app-list--avatars mdc-data-table--margin data-table-battle',
			MultiSelect: false,
			ShowRowIndex: false,
			EnableSort: false,
			Columns: [{
				Content: NP.RM.getString('Name'),
				PropertyContent: 'name',
				Width: '50%'
			}, {
				Content: 'Border Value',
				PropertyContent: 'borderValue',
				Width: '50%'
			}],
			ShowPaginator: false,
			EvItemClick: (s: object, e: { Item: LevelMetaInfo }) =>
			{
				(new MetaLevelEditDialog({
					Item: e.Item,
					EvClosed: () => this.refresh()
				})).show()
			}
		}));

		this.refresh()
	}


	async refresh()
	{
		let items = await ServerAPI.get<LevelMetaInfo[]>("/fantasy/getMetaLevelsInfo")
		this._dataTable.setRows(items);
	}
}


export interface LevelMetaInfo {
	id: number
	name: string
	borderValue: number
}
